<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="atinuss-long-range-pursuit-vessel.-class-117">
<h1>Atinus’s Long-Range-Pursuit<br/> Vessel. Class 117</h1>
<p>Zin and Ohna walk up the ramp into the LRPV 117. It feels so much like their old ship the Vengeance it gives them the equivalent of goose bumps; it makes their scales quiver. Atinus walks down to meet them, pushing her two thumbs together in the traditional Randorian greeting. Zin and Ohna return the gesture. Atinus waves them over to a small room with chairs and a desk; she sits behind it, firing up the computer. It is voice-activated.</p>
<p>“Hello, computer, open file CRD980, please.” She waves the pair to sit down in the seats in front of the desk.</p>
<p>“CRD980 open and awaiting input,” purrs the metallic voice of the computer.</p>
<p>“We have all your call logs going back aeons; we need more details on certain parts. Especially the dealings you had with the Anunnaki, so start at the beginning and tell me how it went. Computer, start recording,” orders Atinus.</p>
<p>“Recording.”</p>
<p>“Well, Atinus, it went like this,” starts Zin, beside him Ohna nods in agreement.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?290c2ee0